"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSManageMyUsersComponent = void 0;
const core_1 = require("@angular/core");
const _ = require("underscore");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const searchfilter_pipe_1 = require("../../pipes/searchfilter.pipe");
const helper_service_1 = require("../../services/helper.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSManageMyUsersComponent {
    constructor(accountDetailService, helperService, modalService) {
        this.accountDetailService = accountDetailService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.sortFilterArray = ['1-10', '20 lines', '50 lines', '100 lines'];
        this.openedSubList = [];
        this.selectedSortNumber = '1-10';
        this.pager = {};
        this.removeUserTmpCnt = 0;
        this.userDetails = new core_1.EventEmitter();
        this.noOfUsers = new core_1.EventEmitter();
        this.removeUserMessage = new core_1.EventEmitter();
    }
    ngOnInit() {
        this.roleId = 'userTypeOption';
        this.getAccountAccessInfo();
        this.subLinesLoader = false;
        this.userAddedSuccessfully = '';
        this.userDeletedSuccessfully = '';
        this.noSearchResultFound = false;
        this.setPage(1, 10);
        this.selectedSortNumber = '1-10';
        this.onSelectSort(this.selectedSortNumber);
        this.isUserDeleted = false;
    }
    ngOnChanges() {
        if (this.users) {
            if (this.users.indexOf('Add') !== -1) {
                this.userAddedSuccessfully = 'User Added Successfully';
                this.getAccountAccessInfo();
            }
            else if (this.users.indexOf('Update') !== -1) {
                this.resetMessage();
                this.userAddedSuccessfully = 'User Updated Successfully';
                this.getAccountAccessInfo();
            }
            else if (this.users.indexOf('remove') !== -1) {
                this.resetMessage();
            }
            this.userDeletedSuccessfully = '';
        }
    }
    getAccountAccessInfo() {
        this.loader = true;
        this.accountDetailService.getAccountAccessPermission().subscribe((accountInfo) => {
            this.loader = false;
            this.accountAccessUsers = accountInfo;
            this.filterAccountAccessUsers = accountInfo;
            if (this.accountAccessUsers && this.isUserDeleted === false) {
                this.noOfUsers.emit(this.accountAccessUsers.length);
            }
            if (this.isUserDeleted) {
                this.isUserDeleted = false;
            }
            this.setPage(1, 10);
            this.selectedSortNumber = '1-10';
            this.onSelectSort(this.selectedSortNumber);
            if (this.accountAccessUsers.length === 0) {
                this.resetMessage();
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    editUser(users) {
        this.tmpCount++;
        const roleDetails = {
            userName: users.userName,
            email: users === null || users === void 0 ? void 0 : users.email,
            phoneNumber: users === null || users === void 0 ? void 0 : users.phoneNumber,
            role: {
                roleId: users.role.roleId,
                roleName: users.role.roleName,
                roleDesc: this.tmpCount
            },
        };
        this.userDetails.emit(roleDetails);
        this.getAccountAccessInfo();
        this.resetMessage();
    }
    removeUserPopUp(userDetail) {
        this.removeUserTmpCnt++;
        this.removeUserMessage.emit('deleteuser ' + this.removeUserTmpCnt);
        this.user = userDetail;
        this.open(this.deleteUser);
        this.resetMessage();
    }
    removeUser() {
        this.resetMessage();
        const updateRoleDetails = {
            'userName': this.user.userName,
        };
        this.loader = true;
        this.accountDetailService.removeAccountAccessPermission(updateRoleDetails).subscribe((accountInfo) => {
            this.loader = false;
            this.userDeletedSuccessfully = 'User Deleted Successfully';
            this.userAddedSuccessfully = '';
            this.isUserDeleted = true;
            this.getAccountAccessInfo();
        }, (err) => {
            this.error = err;
            if (err.errorMessage === 'USER_DOES_NOT_EXISTS_ERROR') {
                this.error = 'User Does Not Exists.';
            }
            else {
                this.error = err.errorMessage;
            }
            this.loader = false;
        });
    }
    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    onChangeUserType(userType) {
    }
    onInputSearchChange(searchTextQuery) {
        this.resetMessage();
        const searchPipe = new searchfilter_pipe_1.SearchFilterPipe();
        this.isSearch = true;
        if (!_.isEmpty(searchTextQuery)) {
            searchTextQuery = searchTextQuery.replace(/\(|\)|-| /g, '');
        }
        // eslint-disable-next-line max-len
        this.filterAccountAccessUsers = searchPipe.transform(this.accountAccessUsers, { 'userName': searchTextQuery, 'isSearchData': this.isSearch }, false);
        if (this.filterAccountAccessUsers && this.filterAccountAccessUsers.length === 0) {
            this.noSearchResultFound = true;
        }
        else {
            this.noSearchResultFound = false;
        }
        this.selectedSortNumber = '1-10';
        this.onSelectSort(this.selectedSortNumber);
    }
    setPage(page, pageSize) {
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20 lines') {
            pageSize = 20;
        }
        else if (pageSize === '50 lines') {
            pageSize = 50;
        }
        else if (pageSize === '100 lines') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.filterAccountAccessUsers !== null && this.filterAccountAccessUsers !== undefined
            && page !== undefined) {
            this.pager = this.helperService.getPager(this.filterAccountAccessUsers.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
        }
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20 lines') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50 lines') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100 lines') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    resetMessage() {
        this.userAddedSuccessfully = '';
        this.userDeletedSuccessfully = '';
    }
    titleCaseWord(roleName) {
        const wordToUppercase = 'it';
        if (!roleName) {
            return roleName;
        }
        else {
            const words = roleName.toLowerCase().split(' ');
            const transformedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
            const regex = new RegExp(`\\b${wordToUppercase}\\b`, 'gi');
            return transformedWords.join(' ').replace(regex, (match) => (match.toUpperCase()));
        }
    }
}
exports.CSManageMyUsersComponent = CSManageMyUsersComponent;
//# sourceMappingURL=managemyusers.component.js.map